export const sendEmail = async ({ name, email, subject, message }) => {
  console.log("ENV SMTP USER:", process.env.REACT_APP_SMTP_USER);
  console.log("ENV SMTP USER:", process.env.REACT_APP_SMTP_PASS);

  const payload = {
    smtpHost: "smtp.gmail.com",
    smtpPort: 587,
    smtpUser: process.env.REACT_APP_SMTP_USER,
    smtpPass: process.env.REACT_APP_SMTP_PASS,
    from: "Website Contact Form",
    to: "swarajyadigital25@gmail.com",
    subject: `New message from ${name}: ${subject}`,
    text: `Message from ${name} (${email}):\n\n${message}`,
    html: `<p><strong>Name:</strong> ${name}</p>
           <p><strong>Email:</strong> ${email}</p>
           <p><strong>Subject:</strong> ${subject}</p>
           <p><strong>Message:</strong><br/>${message}</p>`
  };

  try {
    const response = await fetch("https://sendemail-3jje2wggzq-uc.a.run.app/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to send email");
    }

    return await response.json(); // success
  } catch (error) {
    throw error;
  }
};

export const sendQuotationEmail = async ({ name, email, productName }) => {
  console.log("ENV SMTP USER:", process.env.REACT_APP_SMTP_USER);

  const payload = {
    smtpHost: "smtp.gmail.com",
    smtpPort: 587,
    smtpUser: process.env.REACT_APP_SMTP_USER,
    smtpPass: process.env.REACT_APP_SMTP_PASS,
    from: "Website Contact Form",
    to: "swarajyadigital25@gmail.com",
    subject: `New quotation request from ${name}: ${productName}`,
    text: `Quotation request from ${name} (${email}):\n\nProduct: ${productName}`,
    html: `<p><strong>Name:</strong> ${name}</p>
           <p><strong>Email:</strong> ${email}</p>
           <p><strong>Product Name:</strong> ${productName}</p>`
  };

  try {
    const response = await fetch("https://sendemail-3jje2wggzq-uc.a.run.app/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to send email");
    }

    return await response.json(); // success
  } catch (error) {
    throw error;
  }
};
